import React, { useState } from "react";
// Pastikan path ke LogoGMIM sudah benar
import LogoGMIM from "../../assets/LogoGMIM.png";
import { Link } from "react-router-dom";
// Pastikan inisialisasi auth dan db sudah diekspor dari file firebase.js
// 'db' DI SINI ADALAH OBJEK REALTIME DATABASE
import { auth, db } from "../../config/firebase";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
// IMPOR BARU UNTUK REALTIME DATABASE
import { ref, set } from "firebase/database";

// Helper function untuk memformat pesan error dari Firebase
const formatFirebaseError = (code) => {
  switch (code) {
    case "auth/email-already-in-use":
      return "Email sudah terdaftar. Silakan gunakan email lain.";
    case "auth/invalid-email":
      return "Format email tidak valid.";
    case "auth/weak-password":
      return "Password terlalu lemah. Harus minimal 6 karakter.";
    case "auth/operation-not-allowed":
      return "Pendaftaran email/password belum diaktifkan di backend anda.";
    default:
      // Error lain, termasuk kegagalan Realtime Database Rules
      return "Terjadi kesalahan saat pendaftaran. Silakan coba lagi.";
  }
};

const Register = () => {
  // States untuk input form
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");

  // States untuk UI
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    // Validasi sederhana, memastikan role sudah dipilih
    if (!role) {
      setMessage({
        type: "error",
        text: "Silakan pilih Role (Admin/Operator).",
      });
      setLoading(false);
      return;
    }

    try {
      // 1. Membuat user di Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // 2. Mengupdate Display Name (opsional)
      await updateProfile(user, {
        displayName: `${firstName} ${lastName}`,
      });

      // 3. Menyimpan data tambahan ke REALTIME DATABASE
      // Path: "users/{user.uid}"
      await set(ref(db, "users/" + user.uid), {
        firstName,
        lastName,
        email,
        role,
        verified: false, // Akun akan menunggu verifikasi
        createdAt: new Date().toISOString(), // Simpan tanggal sebagai ISO String
      });

      // 4. Reset form dan tampilkan pesan sukses
      setFirstName("");
      setLastName("");
      setEmail("");
      setPassword("");
      setRole("");
      setMessage({
        type: "success",
        text: "Pendaftaran berhasil! Akun Anda menunggu verifikasi admin.",
      });
    } catch (error) {
      console.error("Register error:", error);

      let errorMessage;
      // Firebase Auth Error Code
      if (error.code) {
        errorMessage = formatFirebaseError(error.code);
      } else {
        // Jika ada error dari Realtime Database (misalnya Rules), error.message akan digunakan
        errorMessage =
          error.message || "Terjadi kesalahan saat menyimpan data.";
      }

      setMessage({
        type: "error",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img src={LogoGMIM} alt="Logo GMIM" className="auth-logo" />

        <h2>Buat Akun Admin & Operator</h2>
        <p>Isi data di bawah untuk mendaftar</p>

        {/* --- Pesan Status --- */}
        {message && (
          <div
            style={{
              padding: "10px",
              borderRadius: "4px",
              backgroundColor:
                message.type === "success" ? "#e6ffe6" : "#ffe6e6",
              color: message.type === "success" ? "#006600" : "#cc0000",
              border: `1px solid ${
                message.type === "success" ? "#00cc00" : "#ff0000"
              }`,
              marginBottom: "15px",
              textAlign: "center",
            }}
          >
            {message.text}
          </div>
        )}
        {/* -------------------- */}

        <form onSubmit={handleRegister}>
          <div className="name-group">
            <input
              type="text"
              placeholder="Nama Depan"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="auth-input"
              required
            />
            <input
              type="text"
              placeholder="Nama Belakang"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="auth-input"
              required
            />
          </div>

          <input
            type="email"
            placeholder="Masukkan email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="auth-input"
            required
          />

          <input
            type="password"
            placeholder="Masukkan password (minimal 6 karakter)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="auth-input"
            required
            minLength={6}
          />

          <select
            className="auth-input"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
          >
            <option value="">Pilih Role</option>
            <option value="admin">Admin</option>
            <option value="operator">Operator</option>
          </select>

          <button
            type="submit"
            className={`auth-button ${loading ? "disabled" : ""}`}
            disabled={loading}
          >
            {loading ? "Memproses..." : "Daftar"}
          </button>

          <p className="auth-footer info-text">
            Pendaftaran akun akan **diverifikasi terlebih dahulu** oleh Admin
            sebelum Anda bisa menggunakannya.
          </p>
        </form>

        <p className="auth-footer">
          Sudah punya akun?
          <Link to="/login" className="auth-link">
            Login di sini
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
